import styled, { css } from 'styled-components'

const alternativeCss = (props: any) => {
  return `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${props.theme.spacing.default} ${props.theme.spacing.default};
  border-radius: ${props.theme.radius.small};
  background-color: ${props.theme.colors.black[100]};

  & > div:first-of-type {
    img {
      height: 1.5rem;
      margin-right: ${props.theme.spacing.small};
    }
  }

  span {
    font-size: ${props.theme.font.default};
    font-weight: ${props.theme.fontWeight.medium};
    margin-left: ${props.theme.spacing.small};
  }
  `
}

const variants: Record<'default' | 'alternative' | 'light', (props: any) => string> = {
  default: props => `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: ${props.theme.spacing.default} ${props.theme.spacing.default};
    border-radius: ${props.theme.radius.small};
    background-color: ${props.theme.colors.black[100]};

    & > div:first-of-type {
      img {
        height: 1.5rem;
        margin-right: ${props.theme.spacing.small};
      }
    }

    span {
      font-size: ${props.theme.font.default};
      font-weight: ${props.theme.fontWeight.medium};
      margin-left: ${props.theme.spacing.small};
    }
  `,
  alternative: props => `
    ${alternativeCss(props)}
  `,
  light: props => `
    ${alternativeCss(props)}
    background-color: #F7F7FF;
    
  `,
}

export const Label = styled.section<{ variant?: 'default' | 'alternative' | 'light' }>`
  ${props =>
    css`
      ${variants[props?.variant || 'default'](props)}
    `}
`
